import { useContext } from "react";
import PluginsContext from "components/plugin/plugins-context";

export default (pluginId: string) => {
    const pluginsContext = useContext(PluginsContext);

    return pluginsContext.plugins.find((p) => p.id === pluginId) || undefined;
};
